import { render, staticRenderFns } from "./shared-select.vue?vue&type=template&id=36b5a33c"
import script from "./shared-select.vue?vue&type=script&lang=js"
export * from "./shared-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports